import React from 'react'
import PropTypes from 'prop-types'
import arrowLeft from 'assets/shop/ChevronLeft.png'
import arrowLefDisable from 'assets/shop/ChevronLeftDisable.png'
import './styles.scss'

function Pagination({ totalPages, currentPage, goToPage }) {
  const onPrevPage = () => {
    if (currentPage > 1) {
      goToPage(currentPage - 1)
    }
  }

  const onNextPage = () => {
    if (currentPage < totalPages) {
      goToPage(currentPage + 1)
    }
  }

  return (
    <div className="pagination">
      <button className="prev-button" onClick={onPrevPage} disabled={currentPage === 1}>
        <img src={currentPage === 1 ? arrowLefDisable : arrowLeft} alt="" />
      </button>
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index}
          className={currentPage === index + 1 ? 'active' : ''}
          onClick={() => goToPage(index + 1)}
        >
          {index + 1}
        </button>
      ))}
      <button className="next-button" onClick={onNextPage} disabled={currentPage === totalPages}>
        <img src={currentPage === totalPages ? arrowLefDisable : arrowLeft} alt="" />
      </button>
    </div>
  )
}

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  goToPage: PropTypes.func.isRequired
}

export default Pagination
